import { Flex } from "@mantine/core";
import { IconExternalLink } from "@tabler/icons-react";
import type { MRT_ColumnDef } from "mantine-react-table-open";
import { generatePath } from "react-router";
import { ROUTES } from "../../../../../routes";
import { AnchorLink } from "../../../../AnchorLink/AnchorLink";
import type { FlatLocationOverviewData } from "../../LocationOverview.types";

function getDocumentFolderColumn(): MRT_ColumnDef<FlatLocationOverviewData> {
  return {
    accessorKey: "documentFolder",
    header: "Dokumenten-Ordner",
    size: 190,
    enableGrouping: false,
    Cell: ({ row }) => {
      const { location, todo } = row.original;
      return <DocumentFolder projectId={location.project} todoId={todo} />;
    }
  };
}

interface DocumentFolderProps {
  projectId: string;
  todoId: number | null;
}

function DocumentFolder({ projectId, todoId }: DocumentFolderProps) {
  if (todoId === null) {
    return null;
  }

  const path = generatePath(ROUTES.onboarding.singleTodo, {
    projectId,
    todoId: todoId.toString()
  });

  return (
    <AnchorLink href={path} target="_self">
      <Flex align="center" component="span">
        Ordner <IconExternalLink size="1.2em" />
      </Flex>
    </AnchorLink>
  );
}

export { getDocumentFolderColumn };
